import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

const PaidHitRegistrationButton = (props) => {
    const { isCurrentMemberAdmin, handleRegClick, events } = props;
    const { data: event } = events.currentEvent;
    const isEventInProgress = event.eventState.value === 'in_progress';
    const isEventCompleted = event.eventState.value === 'completed';
    const isEventRegistrationClosed = event.eventState.value === 'registration_closed';
    const isEventRegistrationOpen = event.eventState.value === 'open_registration';
    const isUserRegisteredForEvent = event.registered;

    if (isCurrentMemberAdmin) {
        return null;
    }

    const showRegister = (isEventRegistrationOpen || isUserRegisteredForEvent) && !isEventInProgress && !isEventCompleted;
    const showAlreadyRegistered = isUserRegisteredForEvent && !isEventInProgress && !isEventCompleted;

    const renderButtonText = () => {
        if (showAlreadyRegistered) {
            return 'Edit Registration';
        }
        if (isEventRegistrationClosed) {
            return 'Registration Closed';
        }
        if (isEventInProgress) {
            return 'In Progress';
        }
        if (isEventCompleted) {
            return 'Completed';
        }
    };

    return (
        <div className="register mt16">
            {showRegister ? (
                <button
                    type="button"
                    className={`btn btn-primary btn-lg btn-block text-uppercase ${event.published ? '' : 'disabled'}`}
                    onClick={handleRegClick}
                >
                    {showAlreadyRegistered ? 'Edit Registration' : 'Register'}
                </button>
            ) : (
                <button
                    type="button"
                    className="btn btn-primary btn-lg btn-block text-uppercase"
                    disabled={true}
                >
                    {renderButtonText()}
                </button>
            )}
            {!isEventInProgress && !isEventCompleted && !isUserRegisteredForEvent && (
                <p className="text-small text-center">{event.eventSchedule.registrationEndString}</p>
            )}
        </div>
    );
};

function mapStateToProps({ events }) {
    return { events };
}

export default withRouter(connect(mapStateToProps, null)(PaidHitRegistrationButton));
